import React, { useEffect } from "react";
import { PhoneIcon, PlusIcon, MinusIcon } from "@heroicons/react/24/outline";
import { useDispatch, useSelector } from "react-redux";
import {
  incrementPhoneCall,
  decrementPhoneCall,
  fetchPhoneCalls,
} from "../../store/thunks/phoneCallThunk";

export default function IncrementButton({ icon, label, className }) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const { phoneCalls, loading, error } = useSelector(
    (state) => state.phoneCalls
  );

  const date = new Date().toISOString().split("T")[0];
  const numCallsToday = phoneCalls[date]?.count || 0;

  useEffect(() => {
    dispatch(fetchPhoneCalls(date));
  }, [date, dispatch]);

  const handleIncrement = async () => {
    await dispatch(incrementPhoneCall(user._id));
    dispatch(fetchPhoneCalls(date));
  };

  const handleDecrement = async () => {
    if (numCallsToday > 0) {
      await dispatch(decrementPhoneCall(user._id));
      dispatch(fetchPhoneCalls(date));
    }
  };

  return (
    <div className="relative group">
      <div className={`flex items-center justify-between px-1 h-8 md:h-9 bg-white text-gray-700 border border-gray-200 shadow-sm rounded-sm hover:bg-gray-50 focus-within:ring-2 focus-within:ring-blue-500 transition-colors min-w-[108px] md:min-w-[120px]`}>
        <button
          onClick={handleDecrement}
          disabled={numCallsToday === 0}
          className={`flex items-center justify-center p-1 rounded hover:bg-gray-100 ${numCallsToday === 0 ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
          title="Decrease call count"
        >
          <MinusIcon className="h-3 w-3 md:h-4 md:w-4" />
        </button>

        <div className="flex items-center gap-0.5">
          {icon}
          <span className="text-sm font-medium min-w-[1ch] text-center">
            {loading ? "..." : numCallsToday}
          </span>
        </div>

        <button
          onClick={handleIncrement}
          className="flex items-center justify-center p-1 rounded hover:bg-gray-100 cursor-pointer"
          title="Increase call count"
        >
          <PlusIcon className="h-3 w-3 md:h-4 md:w-4" />
        </button>
      </div>
      <span className="absolute -top-6 left-1/2 -translate-x-1/2 hidden group-hover:flex text-xs bg-black text-white px-2 py-1 rounded whitespace-nowrap">
        {label}
      </span>
    </div>
  );
}
